export const TV_LIVE_STREAMS_FETCH_SUCCESS = 'TV_LIVE_STREAMS_FETCH_SUCCESS';
export const TV_LIVE_STREAMS_FETCH_IN_PROGRESS = 'TV_LIVE_STREAMS_FETCH_IN_PROGRESS';
export const TV_LIVE_STREAMS_FETCH_ERROR = 'TV_LIVE_STREAMS_FETCH_ERROR';

export const TV_LIVE_STREAM_FETCH_SUCCESS = 'TV_LIVE_STREAM_FETCH_SUCCESS';
export const TV_LIVE_STREAM_FETCH_IN_PROGRESS = 'TV_LIVE_STREAM_FETCH_IN_PROGRESS';
export const TV_LIVE_STREAM_FETCH_ERROR = 'TV_LIVE_STREAM_FETCH_ERROR';

export const TV_LIVE_STREAM_ADD_SUCCESS = 'TV_LIVE_STREAM_ADD_SUCCESS';
export const TV_LIVE_STREAM_ADD_IN_PROGRESS = 'TV_LIVE_STREAM_ADD_IN_PROGRESS';
export const TV_LIVE_STREAM_ADD_ERROR = 'TV_LIVE_STREAM_ADD_ERROR';

export const TV_LIVE_STREAM_UPDATE_SUCCESS = 'TV_LIVE_STREAM_UPDATE_SUCCESS';
export const TV_LIVE_STREAM_UPDATE_IN_PROGRESS = 'TV_LIVE_STREAM_UPDATE_IN_PROGRESS';
export const TV_LIVE_STREAM_UPDATE_ERROR = 'TV_LIVE_STREAM_UPDATE_ERROR';

export const TV_LIVE_STREAM_DELETE_SUCCESS = 'TV_LIVE_STREAM_DELETE_SUCCESS';
export const TV_LIVE_STREAM_DELETE_IN_PROGRESS = 'TV_LIVE_STREAM_DELETE_IN_PROGRESS';
export const TV_LIVE_STREAM_DELETE_ERROR = 'TV_LIVE_STREAM_DELETE_ERROR';

export const SHOW_LIVE_STREAM_DELETE_DIALOG = 'SHOW_LIVE_STREAM_DELETE_DIALOG';
export const HIDE_LIVE_STREAM_DELETE_DIALOG = 'HIDE_LIVE_STREAM_DELETE_DIALOG';

export const TV_LIVE_STREAM_URL_FETCH_SUCCESS = 'TV_LIVE_STREAM_URL_FETCH_SUCCESS';
export const TV_LIVE_STREAM_URL_FETCH_IN_PROGRESS = 'TV_LIVE_STREAM_URL_FETCH_IN_PROGRESS';
export const TV_LIVE_STREAM_URL_FETCH_ERROR = 'TV_LIVE_STREAM_URL_FETCH_ERROR';

export const TV_LIVE_STREAM_PUBLISH_SUCCESS = 'TV_LIVE_STREAM_PUBLISH_SUCCESS';
export const TV_LIVE_STREAM_PUBLISH_IN_PROGRESS = 'TV_LIVE_STREAM_PUBLISH_IN_PROGRESS';
export const TV_LIVE_STREAM_PUBLISH_ERROR = 'TV_LIVE_STREAM_PUBLISH_ERROR';

export const TV_LIVE_STREAM_UN_PUBLISH_SUCCESS = 'TV_LIVE_STREAM_UN_PUBLISH_SUCCESS';
export const TV_LIVE_STREAM_UN_PUBLISH_IN_PROGRESS = 'TV_LIVE_STREAM_UN_PUBLISH_IN_PROGRESS';
export const TV_LIVE_STREAM_UN_PUBLISH_ERROR = 'TV_LIVE_STREAM_UN_PUBLISH_ERROR';

export const LIVE_STREAM_SETUP_DIALOG_SHOW = 'LIVE_STREAM_SETUP_DIALOG_SHOW';
export const LIVE_STREAM_SETUP_DIALOG_HIDE = 'LIVE_STREAM_SETUP_DIALOG_HIDE';

export const LIVE_STREAM_SETUP_NAME_SET = 'LIVE_STREAM_SETUP_NAME_SET';
export const LIVE_STREAM_SETUP_NODE_SET = 'LIVE_STREAM_SETUP_NODE_SET';
export const LIVE_STREAM_ID_SET = 'LIVE_STREAM_ID_SET';
export const LIVE_STREAM_KEY_SET = 'LIVE_STREAM_KEY_SET';
export const LIVE_STREAM_DESCRIPTION_SET = 'LIVE_STREAM_DESCRIPTION_SET';
export const LIVE_STREAM_THUMBNAIL_SET = 'LIVE_STREAM_THUMBNAIL_SET';
export const LIVE_STREAM_SCHEDULE_START_DATE_SET = 'LIVE_STREAM_SCHEDULE_START_DATE_SET';
export const LIVE_STREAM_SCHEDULE_END_DATE_SET = 'LIVE_STREAM_SCHEDULE_END_DATE_SET';
export const LIVE_STREAM_VISIBILITY_SET = 'LIVE_STREAM_VISIBILITY_SET';

export const LIVE_VIDEOS_LIST_FETCH_SUCCESS = 'LIVE_VIDEOS_LIST_FETCH_SUCCESS';
export const LIVE_VIDEOS_LIST_FETCH_IN_PROGRESS = 'LIVE_VIDEOS_LIST_FETCH_IN_PROGRESS';
export const LIVE_VIDEOS_LIST_FETCH_ERROR = 'LIVE_VIDEOS_LIST_FETCH_ERROR';

export const BROADCAST_LIST_FETCH_SUCCESS = 'BROADCAST_LIST_FETCH_SUCCESS';
export const BROADCAST_LIST_FETCH_IN_PROGRESS = 'BROADCAST_LIST_FETCH_IN_PROGRESS';
export const BROADCAST_LIST_FETCH_ERROR = 'BROADCAST_LIST_FETCH_ERROR';

export const SCHEDULE_LIVE_SWITCH_SET = 'SCHEDULE_LIVE_SWITCH_SET';
export const YOUTUBE_SETTINGS_TAB_SET = 'YOUTUBE_SETTINGS_TAB_SET';
export const SELECTED_DESTINATIONS_LIST_SET = 'SELECTED_DESTINATIONS_LIST_SET';

export const REMOVE_MEDIA_NODE_FETCH_SUCCESS = 'REMOVE_MEDIA_NODE_FETCH_SUCCESS';
export const REMOVE_MEDIA_NODE_FETCH_IN_PROGRESS = 'REMOVE_MEDIA_NODE_FETCH_IN_PROGRESS';
export const REMOVE_MEDIA_NODE_FETCH_ERROR = 'REMOVE_MEDIA_NODE_FETCH_ERROR';

export const UPDATE_DESTINATIONS_FETCH_SUCCESS = 'UPDATE_DESTINATIONS_FETCH_SUCCESS';
export const UPDATE_DESTINATIONS_FETCH_IN_PROGRESS = 'UPDATE_DESTINATIONS_FETCH_IN_PROGRESS';
export const UPDATE_DESTINATIONS_FETCH_ERROR = 'UPDATE_DESTINATIONS_FETCH_ERROR';

export const DELETE_DESTINATION_FETCH_SUCCESS = 'DELETE_DESTINATION_FETCH_SUCCESS';
export const DELETE_DESTINATION_FETCH_IN_PROGRESS = 'DELETE_DESTINATION_FETCH_IN_PROGRESS';
export const DELETE_DESTINATION_FETCH_ERROR = 'DELETE_DESTINATION_FETCH_ERROR';

export const SYNC_STUDIO_LIVE_STREAM_FETCH_SUCCESS = 'SYNC_STUDIO_LIVE_STREAM_FETCH_SUCCESS';
export const SYNC_STUDIO_LIVE_STREAM_FETCH_IN_PROGRESS = 'SYNC_STUDIO_LIVE_STREAM_FETCH_IN_PROGRESS';
export const SYNC_STUDIO_LIVE_STREAM_FETCH_ERROR = 'SYNC_STUDIO_LIVE_STREAM_FETCH_ERROR';

export const YOUTUBE_REFRESH_ACCESS_TOKEN_SUCCESS = 'YOUTUBE_REFRESH_ACCESS_TOKEN_SUCCESS';
export const YOUTUBE_REFRESH_ACCESS_TOKEN_IN_PROGRESS = 'YOUTUBE_REFRESH_ACCESS_TOKEN_IN_PROGRESS';
export const YOUTUBE_REFRESH_ACCESS_TOKEN_ERROR = 'YOUTUBE_REFRESH_ACCESS_TOKEN_ERROR';

export const SET_STREAM_INFO_EMPTY = 'SET_STREAM_INFO_EMPTY';

export const REMOVE_MEDIANODE_CONFIRM_DIALOG_SHOW = 'REMOVE_MEDIANODE_CONFIRM_DIALOG_SHOW';
export const REMOVE_MEDIANODE_CONFIRM_DIALOG_HIDE = 'REMOVE_MEDIANODE_CONFIRM_DIALOG_HIDE';

export const GO_LIVE_FETCH_SUCCESS = 'GO_LIVE_FETCH_SUCCESS';
export const GO_LIVE_FETCH_IN_PROGRESS = 'GO_LIVE_FETCH_IN_PROGRESS';
export const GO_LIVE_FETCH_ERROR = 'GO_LIVE_FETCH_ERROR';

export const FETCH_YOUTUBE_STATUS_SUCCESS = 'FETCH_YOUTUBE_STATUS_SUCCESS';
export const FETCH_YOUTUBE_STATUS_IN_PROGRESS = 'FETCH_YOUTUBE_STATUS_IN_PROGRESS';
export const FETCH_YOUTUBE_STATUS_ERROR = 'FETCH_YOUTUBE_STATUS_ERROR';
